/*
 * Copyright (c) 2020, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: MIT
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/MIT
 */

import { MapCreate } from '../shared/utils';
import { addKnownEventName } from './element';

export const { addEventListener: addEventListenerOriginal, dispatchEvent: dispatchEventOriginal } =
  EventTarget.prototype;

const addEventListenerDistortion = function addEventListener(
  this: EventTarget,
  ...args: Parameters<typeof EventTarget.prototype.addEventListener>
) {
  // track the event name that libs in oasis will be listening for
  // in order to flatten those events before re-targeting
  const [name] = args;
  addKnownEventName(name);
  return addEventListenerOriginal.apply(this, args);
};

export default MapCreate([[addEventListenerOriginal, addEventListenerDistortion]]);
